import React from 'react';
import ReactDOM from 'react-dom';
import Grounds from '@ifeng-fe/three_terminal/es/base/grounds';
import './reset.css';
import Layout from './layout';

// 最大化
Grounds.maximization();
// Grounds.setMultiToolBarHidden(true);

/* eslint-disable */
ReactDOM.render(<Layout content={allData} />, document.getElementById('root'));
/* eslint-enable */
